
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as L from 'leaflet';
import { Overlay } from '../models/Overlay';

@Component({ name: 'LeafletMapImgOverlay' })
export default class LeafletMapImgOverlay extends Vue {
  @Prop() map!: L.Map;
  @Prop() layer!: L.LayerGroup | L.Map;
  @Prop() overlay!: Overlay;

  mapOverlay = null as L.ImageOverlay | null;
  imageUrl = '';

  @Watch('overlay')
  onOverlayChange(val: Overlay, oldVal: Overlay) {
    if (this.mapOverlay && val.raster.TimeStamp != oldVal.raster.TimeStamp && val.raster.Type == oldVal.raster.Type) {
      const bounds = new L.LatLngBounds(new L.LatLng(this.overlay.sw.Item1, this.overlay.sw.Item2), new L.LatLng(this.overlay.ne.Item1, this.overlay.ne.Item2));
      URL.revokeObjectURL(this.imageUrl);
      this.imageUrl = URL.createObjectURL(val.blob);
      this.mapOverlay.setUrl(this.imageUrl);
      this.mapOverlay.setBounds(bounds);
    } else if (this.mapOverlay && (val == null || val == undefined)) {
      URL.revokeObjectURL(this.imageUrl);
      this.mapOverlay.remove();
    }
  }

  destroyed() {
    this.destroyResources();
  }
  private destroyResources() {
    URL.revokeObjectURL(this.imageUrl);
    this.mapOverlay?.remove();
  }

  deactivated() {
    this.destroyResources();
  }

  mounted() {
    this.imageUrl = URL.createObjectURL(this.overlay.blob);
    const zIndex = this.overlay.zIndex;
    const bounds = new L.LatLngBounds(new L.LatLng(this.overlay.sw.Item1, this.overlay.sw.Item2), new L.LatLng(this.overlay.ne.Item1, this.overlay.ne.Item2));
    this.mapOverlay = new L.ImageOverlay(this.imageUrl, bounds).addTo(this.map).setZIndex(zIndex);
  }
}
